$(function() {

    $(document).ready(function() {
        if (!getCookie('block_interstitial_signup') && $('#interstitial-signup-overlay').length) {
            setTimeout(openOverlay, 20000);
        }
    });

    $(document).on('keydown', function(event) {
        if (event.key == 'Escape' && $('#interstitial-signup-overlay').hasClass('active')) {
            closeOverlay();
        }
    });

    $('#interstitial-signup-overlay-close-button').on('click', closeOverlay);

    $('#interstitial-signup-overlay .background-overlay').on('click', closeOverlay);

    function openOverlay() {
        $('html').addClass('noscroll');
        $('#interstitial-signup-overlay').addClass('active');
        setTrap($('#interstitial-signup-overlay'));
    }

    function closeOverlay() {
        var closecount = getCookie('interstitial_signup_close_count');
        var shouldBlock = getCookie('block_interstitial_signup');

        if (!shouldBlock && !closecount) {
            /* first time closing, hide for for 4 minutes */
            setCookie('interstitial_signup_close_count', 1, 365);
            setCookie('block_interstitial_signup', true, 0, 4);
        } else if (!shouldBlock && closecount >= 1) {
            /* second time closing, hide for 10 days */
            setCookie('interstitial_signup_close_count', 2, 365);
            setCookie('block_interstitial_signup', true, 10);
        }

        $('html').removeClass('noscroll');
        $('#interstitial-signup-overlay').removeClass('active');
    }

    function setTrap(modal) {
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableContent = modal.find(focusableElements);
        const firstFocusableElement = focusableContent[0]; // get first element to be focused inside modal
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

        $(document).on('keydown', function(e) {
            var isTabPressed = e.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else { // if tab key is pressed
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        });
    }

    /* cookie handling */
    function setCookie(cname, cvalue, expdays, expminutes) {
        const expdate = new Date();

        var newcookie = cname + '=' + cvalue;
        if (expdays > 0 || expminutes > 0) {
            expdate.setTime(
                expdate.getTime()
                + (expdays * 86400000)
                + (expminutes * 60000)
            );
            newcookie += '; expires=' + expdate.toUTCString();
        }
        newcookie += '; path=/';

        document.cookie = newcookie;
    }

    function getCookie(cname) {
        var name = cname + '=';
        var cookiestr = document.cookie.split(';');

        for(var i = 0; i < cookiestr.length; i++) {
            var substr = cookiestr[i];

            while (substr.charAt(0) == ' ') {
                substr = substr.substring(1);
            }

            if (substr.indexOf(name) == 0) {
                return substr.substring(name.length, substr.length);
            }
        }

        return '';
    }

});
